<template>
  <div>
    <b-card>
      <div slot="header">
        {{ $lang.surveyLang.create_survey_group_azmoon }}
      </div>
      <LoadingSpinner :loading="loading" :text="$lang.sending_data" />
      <b-row v-show="!loading">
        <b-col cols="12" md="12">
          <b-alert show variant="info" dismissible>
            <mdicon name="information" size="20" class="mr-1" />
            <strong v-html="alertMessage" />
          </b-alert>
        </b-col>
        <b-col cols="12" md="12">
          <b-form-group
            :label="`${$lang.surveyLang.survey_group_azmoon_name}: `"
            label-for="term"
            :label-cols="this.$config.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="`${$lang.surveyLang.survey_group_azmoon_name}: `"
              :rules="$v.azmoon_selected.$params"
            />

            <selectFind
              :options="azmoon_options"
              v-model="$v.azmoon_selected.$model"
              label="caption"
              :loading="azmoon_loading"
              :isValid="
                $v.azmoon_selected.$dirty ? !$v.azmoon_selected.$error : null
              "
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.azmoon_selected.$error ? 'block' : 'none',
              }"
              id="azmoon_selected_feedback"
            >
              {{
                $lang.error_required
                  | replace($lang.surveyLang.survey_group_azmoon_name)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          class="text-right mt-3"
          v-if="
            includes('admin', parentPermissions) ||
            includes('edit', parentPermissions)
          "
        >
          <b-button
            type="reset"
            class="mr-2"
            variant="outline-danger"
            @click="close"
          >
            <mdicon name="close" size="20" />
            {{ $lang.close }}
          </b-button>
          <b-button variant="success" @click="submit">
            <mdicon name="check" size="20" />
            {{ $lang.submitButton }}
          </b-button>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { pathOr, includes } from "ramda";
import { required } from "vuelidate/lib/validators";
import LoadingSpinner from "@/components/base/LoadingSpinner";
import { generateApiUrl } from "@/shared/utils";

export default {
  validations: {
    azmoon_selected: { required },
  },
  components: {
    LoadingSpinner,
  },
  props: {
    parentPermissions: {
      type: Array,
      default: () => [],
    },
    term: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      code: this.$route.params.code,
      azmoon_selected: null,
      azmoon_options: [],
      azmoon_loading: false,
    };
  },
  computed: {
    alertMessage() {
      const term = pathOr("", ["caption"], this.term);
      return `فقط آزمون های دوره <strong class='text-primary'>${term}</strong> نمایش داده می شود`;
    },
  },
  created() {
    this.getAzmoonCombo();
  },
  methods: {
    pathOr,
    includes,
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    async getAzmoonCombo() {
      try {
        this.azmoon_loading = true;
        const termCode = pathOr(null, ["code"], this.term);
        const url = generateApiUrl(["survey", "azmoon_execute_combo"], [], {
          term_code: termCode,
        });
        const response = await this.$httpService.get(url);
        this.azmoon_options = pathOr([], ["data", "data"], response);
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.azmoon_loading = false;
      }
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$anyError) return;
      try {
        this.loading = true;
        const url =
          this.$config.api_url +
          this.$config.survey.survey_group_azmoon.replace("{0}", this.code);
        const payload = {
          azmoon_id: pathOr(null, ["id"], this.azmoon_selected),
        };
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.close();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
